import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { IMaskModule } from 'angular-imask';
import { CapacidadPagoMComponent } from './capacidad-pago-m.component';

const routes: Routes = [
   { path: 'capacidad_alt', component: CapacidadPagoMComponent/* , canActivate: [LoginGuard] */ },
];

@NgModule({
  declarations: [
    CapacidadPagoMComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbDatepickerModule,
    NgSelectModule,
    IMaskModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes)
  ],
  exports: [CapacidadPagoMComponent]
})
export class CapacidadPagoMModule { }
